var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-container"},[_c('div',{staticClass:"nav-wrapper"},[_vm._m(0),_c('nav',[_c('ul',[_c('li',[_c('router-link',{attrs:{"to":"/tweets","custom":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var href = ref.href;
var navigate = ref.navigate;
var isActive = ref.isActive;
var isExactActive = ref.isExactActive;
return [_c('a',{class:[
                isActive && 'router-link-active',
                isExactActive && 'router-link-exact-active'
              ],attrs:{"href":href},on:{"click":navigate}},[_c('img',{attrs:{"src":[
                  isActive
                    ? require('../assets/icon/icon_home_active.png')
                    : require('../assets/icon/icon_home.png')
                ],"alt":""}}),_c('span',{staticClass:"nav-text"},[_vm._v("首頁")])])]}}])})],1),_c('li',{staticStyle:{"display":"none"}},[_c('router-link',{attrs:{"to":"/notification","custom":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
                var href = ref.href;
                var navigate = ref.navigate;
                var isActive = ref.isActive;
                var isExactActive = ref.isExactActive;
return [_c('a',{class:[
                isActive && 'router-link-active',
                isExactActive && 'router-link-exact-active'
              ],attrs:{"href":href},on:{"click":navigate}},[_c('img',{attrs:{"src":[
                  isActive
                    ? require('../assets/icon/icon_bell_active.svg')
                    : require('../assets/icon/icon_bell.svg')
                ],"alt":""}}),_c('span',{staticClass:"nav-text"},[_vm._v("通知")])])]}}])})],1),_c('li',[_c('router-link',{attrs:{"to":"/chatroom","custom":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
                var href = ref.href;
                var navigate = ref.navigate;
                var isActive = ref.isActive;
                var isExactActive = ref.isExactActive;
return [_c('a',{class:[
                isActive && 'router-link-active',
                isExactActive && 'router-link-exact-active'
              ],attrs:{"href":href},on:{"click":navigate}},[_c('img',{attrs:{"src":[
                  isExactActive
                    ? require('../assets/icon/icon_earth_active.svg')
                    : require('../assets/icon/icon_earth.svg')
                ],"alt":""}}),_c('span',{staticClass:"nav-text"},[_vm._v("公開聊天室")])])]}}])})],1),_c('li',{staticStyle:{"display":"none"}},[_c('router-link',{attrs:{"to":{ name: 'private-chatroom' },"custom":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
                var href = ref.href;
                var navigate = ref.navigate;
                var isActive = ref.isActive;
                var isExactActive = ref.isExactActive;
return [_c('a',{class:[
                isActive && 'router-link-active',
                isExactActive && 'router-link-exact-active'
              ],attrs:{"href":href},on:{"click":navigate}},[_c('img',{attrs:{"src":[
                  isExactActive
                    ? require('../assets/icon/icon_envelope_active.svg')
                    : require('../assets/icon/icon_envelope.svg')
                ],"alt":""}}),_c('span',{staticClass:"nav-text"},[_vm._v("私人訊息")])])]}}])})],1),_c('li',[_c('router-link',{attrs:{"to":{ name: 'user-profile' },"custom":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
                var href = ref.href;
                var navigate = ref.navigate;
                var isActive = ref.isActive;
                var isExactActive = ref.isExactActive;
return [_c('a',{class:[
                isActive && 'router-link-active',
                isExactActive && 'router-link-exact-active'
              ],attrs:{"href":href},on:{"click":navigate}},[_c('img',{attrs:{"src":[
                  isActive
                    ? require('../assets/icon/icon_user_active.png')
                    : require('../assets/icon/icon_user.png')
                ],"alt":""}}),_c('span',{staticClass:"nav-text"},[_vm._v("個人資料")])])]}}])})],1),_c('li',[_c('router-link',{attrs:{"to":{ name: 'setting' },"custom":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
                var href = ref.href;
                var navigate = ref.navigate;
                var isActive = ref.isActive;
                var isExactActive = ref.isExactActive;
return [_c('a',{class:[
                isActive && 'router-link-active',
                isExactActive && 'router-link-exact-active'
              ],attrs:{"href":href},on:{"click":navigate}},[_c('img',{attrs:{"src":[
                  isActive
                    ? require('../assets/icon/icon_setting_active.png')
                    : require('../assets/icon/icon_setting.png')
                ],"alt":""}}),_c('span',{staticClass:"nav-text"},[_vm._v("設定")])])]}}])})],1),_c('li',[_c('div',{staticClass:"post-wrapper"},[_c('unicon',{staticClass:"feather-icon",attrs:{"name":"feather","fill":"#fff","viewBox":"0 0 487.38 487.38","width":"32px","height":"32px"},on:{"click":_vm.showPostHandle}}),_c('button',{staticClass:"btn post-btn",on:{"click":_vm.showPostHandle}},[_vm._v("推文")])],1)])])]),_c('div',{staticClass:"logout"},[_c('button',{staticClass:"btn",on:{"click":_vm.logout}},[_c('img',{attrs:{"src":require("../assets/icon/icon_logout.png"),"alt":""}}),_c('span',{staticClass:"nav-text"},[_vm._v("登出")])])])]),_c('UserPostPopup',{attrs:{"show-popup-view":_vm.showPostView},on:{"after-close":_vm.handleClose}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":require("../assets/icon/Icon.png"),"alt":""}})])}]

export { render, staticRenderFns }